import React, { useEffect, useState } from 'react';
import { TextField, Button, Box, DialogActions, DialogContent, DialogTitle
  , useMediaQuery, Dialog, Snackbar, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useSaveImportKPIMutation } from '../../services/product';
import { useGetImportKPIMutation } from '../../services/home';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import ConfirmDialog from '../tools/comfirmDialog';

export default function CorporateKPIImport({open, setOpen, record, getData}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
	const [saveImportKPI, saveImportKPIResult] = useSaveImportKPIMutation();
  const [getImportKPI, getImportKPIResult] = useGetImportKPIMutation();
	const [item, setItem] = useState({});
  const [alert, setAlert] = useState(false);
	const [excelData, setExcelData] = useState([]);
  const [confirm, setConfirm] = useState(false);

  useEffect(() => {
		setItem(record);
    if(record.department == "M&B")
      getImportKPI();
	}, [record]);

  useEffect(() => {
    if(getImportKPIResult.data)
    {
      const dt = JSON.parse(getImportKPIResult.data);
      setExcelData(dt);
    }
	}, [getImportKPIResult]);

  const handleClose = () => {
    setOpen(false);
  };

	const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0]; // Get the first sheet
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);
        setExcelData(json);
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const onSave = async() =>{
    try {
      setConfirm(false);
      let error = false;
			const formData = new FormData();
			formData.append("data", JSON.stringify(excelData));
			const dt = await saveImportKPI(formData).unwrap();
			if(dt[0].ERROR) error = dt[0].ERROR;
      
      if(error)
        setAlert(error);
      else{
        setAlert("Saved!");
        getData();
        setOpen(false);
      }
    } catch (err) {
      setAlert("Lỗi kết nối!");
      console.error(err);
    }
  }

  const exportToCSV = () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], {type: fileType});
    saveAs(data, "OrderQty.xlsx");
  }

  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" sx={{textAlign: 'center', fontWeight: 600}}>
          {open}
        </DialogTitle>
                {/* <Divider /> */}
        <DialogContent>
          <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
					{excelData.length > 0 && (
						<table style={{border: '1px solid gray'}}>
							<thead>
								<tr>
									{Object.keys(excelData[0]).map((key, index) => (
										<th key={key} style={{borderBottom: '1px solid gray', borderLeft: index?'1px solid gray':'none'}}>{key}</th>
									))}
								</tr>
							</thead>
							<tbody>
								{excelData.map((row, index) => (
									<tr key={index}>
										{Object.values(row).map((cell, cellIndex) => (
											<td key={cellIndex} style={{textAlign: 'center', borderBottom: '1px solid gray', borderLeft: cellIndex?'1px solid gray':'none'}}>{cell}</td>
										))}
									</tr>
								))}
							</tbody>
						</table>
					)}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            CLOSE
          </Button>
          <Button onClick={exportToCSV} autoFocus>
            EXPORT
          </Button>
          <Button onClick={()=>setConfirm("Xác nhận ghi đè toàn bộ dữ liệu?")} autoFocus>
            SAVE
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={alert}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={6000}
        onClose={()=>setAlert(false)}
        message={alert}
        // action={action}
      />

      <ConfirmDialog confirm={confirm} setConfirm={setConfirm} onConfirm={onSave}/>
    </React.Fragment>
  );
}